import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { stylingHelpers } from '../designTokens';

const { flexCenter } = stylingHelpers;

const baseStyles = () => css`
  ${flexCenter()}
  list-style: none;
  padding: 0 0 6px 0;
  margin: 0;
  width: 100%;
  justify-content: space-between;
`;

const NavMenuList = styled('ul')(baseStyles);

NavMenuList.propTypes = {
  children: PropTypes.node,
};

export default NavMenuList;
